import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/forward.svg';

export const IconForward = createIconComponent(Icon);
